module.exports = __webpack_public_path__ + "static/img/1.24b3aa9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/slide/1.jpg
// module id = m5WS
// module chunks = 1